import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { SmallLoading } from '@components/loading';
import { modalBg, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import ModalWrapper from '@components/modal/ModalWrapper';
import { ALERT_BORDER_RADIUS } from '@components/alert/constants';
import { useManageAlertComponent } from '@components/alert/hooks/useManageAlertComponent';
import { AlertComponentProps, AlertTextRenderFunction } from '@components/alert/types';
import { AlertButton } from './AlertButton';

export const AlertComponent = ({ C, hide, position, title, text, actions, loadingIndicator, titleColor, boldPrimary }: AlertComponentProps) => {
  const { isHorizontal, width, scale, font, conf, getFont, getColor, bntWidth, btnBorder, rounding } = useManageAlertComponent({
    C,
    hide,
    actions,
    position,
    boldPrimary,
  });

  const renderText = () => {
    if (!text) return null;

    if (typeof text === 'string') {
      return <Text style={[font['Footnote'], { color: C('Label/Light/Primary'), textAlign: 'center' }]}>{i18n.t(text)}</Text>;
    }

    return (text as AlertTextRenderFunction)({ C, scale, font });
  };

  return (
    <ModalWrapper C={C} backdropColor="Overlay/Light/Dim strong" onBackdropPress={hide}>
      <View
        testID={TEST_IDS.alert.container}
        style={{
          width: scale(width),
          backgroundColor: C(modalBg),
          borderRadius: scale(ALERT_BORDER_RADIUS),
          justifyContent: 'space-between',
          alignSelf: 'center',
        }}
      >
        <View
          style={{
            width: '100%',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            padding: scale(18),
          }}
        >
          <Text
            testID={TEST_IDS.alert.title}
            style={[font['Headline'], { color: C(titleColor || 'Label/Light/Primary'), marginBottom: scale(text ? 4 : 0), textAlign: 'center' }]}
          >
            {i18n.t(title)}
          </Text>
          {loadingIndicator && (
            <View style={{ width: '100%', justifyContent: 'center', paddingVertical: scale(20) }}>
              <SmallLoading />
            </View>
          )}
          {renderText()}
        </View>
        <View
          style={{
            width: '100%',
            borderBottomColor: C('Hairline/Light/No trans'),
            borderBottomWidth: StyleSheet.hairlineWidth,
          }}
        />
        <View
          style={{
            flexDirection: isHorizontal ? 'row' : 'column',
          }}
        >
          {conf.map((b, index) => (
            <AlertButton key={`${b.text}-${index}`} {...{ b, index, C, btnBorder, bntWidth, rounding, getFont, getColor, isHorizontal, hide }} />
          ))}
        </View>
      </View>
    </ModalWrapper>
  );
};
